import { createFileRoute } from '@tanstack/react-router'
import { lazy } from 'react'

const RunConfigurePage = lazy(() => import('@/pages/configure/page').then(m => ({ default: m.RunConfigurePage })))
const OplusConfigurePage = lazy(() => import('@/pages/configure-oplus/page').then(m => ({ default: m.OplusConfigurePage })))

export const Route = createFileRoute('/_protected/workflows/new/$agentId')({
  component: function WorkflowConfigureRoute() {
    const { agentId } = Route.useParams()

    // Route to custom configuration page for NI Optimal+ workflow
    if (agentId === 'ingestion-ni-oplus-user') {
      return <OplusConfigurePage />
    }

    // Default to generic configuration page
    return <RunConfigurePage />
  },
  validateSearch: (search: Record<string, unknown>) => {
    const product_id = search.product_id
    const lot_start_date = search.lot_start_date
    const lot_end_date = search.lot_end_date

    return {
      product_id: typeof product_id === 'string' && product_id.trim() ? product_id.trim() : undefined,
      lot_start_date:
        typeof lot_start_date === 'string' && lot_start_date.trim() ? lot_start_date.trim() : undefined,
      lot_end_date:
        typeof lot_end_date === 'string' && lot_end_date.trim() ? lot_end_date.trim() : undefined,
    }
  },
})

